import { queryAdmin } from '../graphql-client';

const IMPORT_STATUS_QUERY = /* GraphQL */ `
  query getImportStatus($importId: String!) {
    importStatus: getProjectImport(id: $importId) {
      status
      message
      projectId
    }
  }
`;

export const queryImportStatus = queryAdmin(IMPORT_STATUS_QUERY);
